import { createAction, props } from '@ngrx/store';

import { CountryList } from '../../types';
import { SITE_CONTEXT_ACTIONS } from '../site-context-actions.type';

export const loadCountriesAction = createAction(SITE_CONTEXT_ACTIONS.LOAD_COUNTRIES);
export const loadCountriesSuccessAction = createAction(
  SITE_CONTEXT_ACTIONS.LOAD_COUNTRIES_SUCCESS,
  props<{ payload: CountryList }>(),
);
